import { useState } from "react"
import { Tab, Tabs } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import Cabecalho from "../Cabecalho"
import useAppStore from "../../stores/AppStore"

import { CoresAplicativoContextProvider } from "../CadastroAplicativoFornecedor/context/CoresAplicativoContextProvider"
import { CadastroAplicativoContextProvider } from "../CadastroAplicativoFornecedor/context/CadastroAplicativoContextProvider"
import { ParametrosAplicativoContextProvider } from "../CadastroAplicativoFornecedor/context/ParametrosAplicativoContextProvider"
import { ArquivosAplicativoContextProvider } from "../CadastroAplicativoFornecedor/context/ArquivosAplicativoContextProvider"
import { ContratoAplicativoContextProvider } from "../CadastroAplicativoFornecedor/context/ContratoAplicativoContextProvider"
import { EstabelecimentosAplicativoContextProvider } from "../CadastroAplicativoFornecedor/context/EstabelecimentosAplicativoContextProvider"

import { FormularioCoresAplicativo } from "../CadastroAplicativoFornecedor/components/FormularioCoresAplicativo"
import { FormularioCadastroAplicativo } from "../CadastroAplicativoFornecedor/components/FormularioCadastroAplicativo"
import { FormularioParametrosAplicativo } from "../CadastroAplicativoFornecedor/components/FormularioParametrosAplicativo"
import { FormularioArquivosAplicativo } from "../CadastroAplicativoFornecedor/components/FormularioArquivosAplicativo"
import { FormularioContratoAplicativo } from "../CadastroAplicativoFornecedor/components/FormularioContratoAplicativo"
import { FormularioEstabelecimentosAplicativo } from "../CadastroAplicativoFornecedor/components/FormularioEstabelecimentosAplicativo"

const useStyles = makeStyles(theme => ({
    barraAbas: {
        position: "fixed",
        top: "calc(64px + var(--banner-height, 0px))",
        left: "var(--drawer-width, 80px)",
        right: 0,
        zIndex: 2,
        backgroundColor: "white",
        borderBottom: "1px solid #e5e7eb",
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        transition: "left 0.2s ease",
        [theme.breakpoints.down("md")]: {
            left: 0,
            top: 56,
        },
    },
    espacador: {
        height: 48,
    },
}))

// soAdmin: true → visível apenas ao perfil CLIENTEFIEL ("admin"). Os demais
// (ADMINISTRADOR = "administrador") só acessam as abas com soAdmin: false.
const ABAS = [
    {
        label: "Cores do Site",
        soAdmin: false,
        render: () => (
            <CoresAplicativoContextProvider>
                <FormularioCoresAplicativo />
            </CoresAplicativoContextProvider>
        ),
    },
    {
        label: "Cadastro do Aplicativo",
        soAdmin: true,
        render: () => (
            <CadastroAplicativoContextProvider>
                <FormularioCadastroAplicativo />
            </CadastroAplicativoContextProvider>
        ),
    },
    {
        label: "Parâmetros do Aplicativo",
        soAdmin: false,
        render: () => (
            <ParametrosAplicativoContextProvider>
                <FormularioParametrosAplicativo />
            </ParametrosAplicativoContextProvider>
        ),
    },
    {
        label: "Arquivos do Aplicativo",
        soAdmin: false,
        render: () => (
            <ArquivosAplicativoContextProvider>
                <FormularioArquivosAplicativo />
            </ArquivosAplicativoContextProvider>
        ),
    },
    {
        label: "Dados do Contrato",
        soAdmin: true,
        render: () => (
            <ContratoAplicativoContextProvider>
                <FormularioContratoAplicativo />
            </ContratoAplicativoContextProvider>
        ),
    },
    {
        label: "Estabelecimentos do Aplicativo",
        soAdmin: true,
        render: () => (
            <EstabelecimentosAplicativoContextProvider>
                <FormularioEstabelecimentosAplicativo />
            </EstabelecimentosAplicativoContextProvider>
        ),
    },
]

const EditarAplicativo = () => {
    const classes = useStyles()
    const configuracoes = useAppStore(s => s.configuracoes)
    // "admin" (acesso total) = perfil CLIENTEFIEL; "administrador" = acesso restrito.
    const ehClienteFiel = configuracoes?.user?.perfil === "CLIENTEFIEL"

    const abasVisiveis = ABAS.filter(aba => ehClienteFiel || !aba.soAdmin)
    const [abaAtiva, setAbaAtiva] = useState(0)
    const indice = Math.min(abaAtiva, abasVisiveis.length - 1)

    return (
        <div>
            <Cabecalho pagina="Editar Aplicativo" />
            <div className={classes.barraAbas}>
                <Tabs
                    value={indice}
                    onChange={(_, novo) => setAbaAtiva(novo)}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {abasVisiveis.map(aba => (
                        <Tab key={aba.label} label={aba.label} />
                    ))}
                </Tabs>
            </div>
            <div className={classes.espacador} />
            {abasVisiveis[indice]?.render()}
        </div>
    )
}

export default EditarAplicativo
